import { Layout } from "@Components/Layout";
import dynamic from "next/dynamic";
const TermsAndCondition = dynamic(() =>
  import("@Components/Pages/Pre-Footer/Terms-And-Conditions")
);
const TermsAndConditionPage = () => {
  return (
    <Layout>
      <TermsAndCondition />
    </Layout>
  );
};
export default TermsAndConditionPage;
